import React from 'react';
import styled from 'styled-components';
import { ICustomerPaymentDetail } from '../Cashier/socket.interface';
import OrderDetails, { IOrderDetailItemValue } from './components/OrderDetail';
import QrPayments from './components/QrPayment';

const Container = styled.div`
  padding: 0px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  height: 100%;
  display: flex;
  zoom: 1.5;
`;

const TwoColumn = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 24px;
  flex: 1;
`;

interface Props {
  date: string;
  customerName: string;
  customerPhone: string;
  items: Array<IOrderDetailItemValue>;
  subtotal: number;
  cardFee?: number;
  saleTax?: number;
  useTax?: number;
  discount?: number;
  qrCode?: string;
  qrCodeImg?: string;
  QRName?: string;
  total?: number;
  specifyAmount?: number;
  ticketNumber?: number;
  onCancel?: () => void;
  onConfirm?: () => void;
  payments?: ICustomerPaymentDetail;
}

const QRPaymentDetail: React.FC<Props> = ({
  date,
  customerName,
  customerPhone,
  items,
  subtotal,
  cardFee = 0,
  saleTax = 0,
  useTax = 0,
  discount = 0,
  qrCode = '',
  qrCodeImg,
  QRName,
  total = 0,
  specifyAmount,
  ticketNumber = 0,
  onCancel,
  onConfirm,
  payments,
}) => {
  return (
    <Container>
      <TwoColumn>
        <OrderDetails
          date={date}
          customerName={customerName}
          customerPhone={customerPhone}
          items={items}
          subtotal={subtotal}
          cardFee={cardFee}
          saleTax={saleTax}
          useTax={useTax}
          discount={discount}
          ticketNumber={ticketNumber}
        />
        <QrPayments
          payments={payments}
          qrCode={qrCode}
          qrCodeImg={qrCodeImg}
          QRName={QRName}
          total={specifyAmount || total}
          onCancel={onCancel}
          onConfirm={onConfirm}
        />
      </TwoColumn>
    </Container>
  );
};

export default QRPaymentDetail;
